<template>
  <dashboard>
    <template v-slot:content>
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="my-1">
              <b-col lg="4">
                <b-row class="mt-2">
                  <b-col lg="6">
                    <h5 v-if="!refundMode && !transTypeRefundNote">Checkout</h5>
                    <h5 v-if="!refundMode && transTypeRefundNote">
                      Credit Refund
                    </h5>
                    <h5 v-if="refundMode && !transTypeRefundNote">Return</h5>
                  </b-col>
                  <b-col lg="6" class="" v-if="!checkInvoiceSuccess">
                    <div
                      class="total-items d-flex justify-content-end align-items-center"
                      v-if="
                        state.system.settings.multiple_mop.status == 1 &&
                          !refundMode &&
                          !transTypeRefundNote
                      "
                    >
                      <div
                        class="return-mode d-flex"
                        v-if="checkSplitPayEnble > 1"
                      >
                        Split Payment
                        <toggle-btn
                          id="split-payment-toggle"
                          :value="splitPayment"
                          @status="splitPaymentToggle"
                        ></toggle-btn>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col lg="8" class="" v-if="!checkInvoiceSuccess">
                <div class="align-items-center text-right">
                  <!-- <font-awesome-icon
                    :icon="['far', 'question-circle']"
                    size="2x"
                    id="help-tooltip"
                  />-->
                  <!-- <b-tooltip target="help-tooltip" placement="left">Help Tooltip !</b-tooltip> -->
                  <b-col
                    lg="3"
                    class="float-right p-0"
                    v-if="
                      ($store.getters.isOMSEnabled &&
                        state.billing.billing.billing_mode == 'order' &&
                        !['Refund-CN', 'Credit-Note', 'Deposit-DN'].includes(
                          state.billing.billing.order.data.trans_sub_type
                        )) ||
                        state.billing.trans_sub_type == 'order'
                    "
                  >
                    <b-button
                      variant="primary"
                      block
                      :disabled="isOrderBtnEnabled"
                      @click="orderCreation"
                    >
                      {{
                        $store.getters.orderPaymentMode
                          ? "Place Order"
                          : "Back to Order"
                      }}
                    </b-button>
                  </b-col>
                  <b-col
                    lg="3"
                    class="float-right pr-2"
                    v-show="
                      $store.getters.isOMSEnabled &&
                        state.billing.billing.billing_mode == 'order' &&
                        !['Refund-CN', 'Credit-Note', 'Deposit-DN'].includes(
                          state.billing.billing.order.data.trans_sub_type
                        ) &&
                        $store.getters.orderPaymentMode
                    "
                  >
                    <b-button
                      block
                      variant="outline-primary"
                      @click="orderDueDate('btn')"
                      >Fulfilment Options</b-button
                    >
                  </b-col>
                  <b-col
                    lg="3"
                    class="float-right p-0"
                    v-if="
                      ['Refund-CN', 'Credit-Note', 'Deposit-DN'].includes(
                        state.billing.billing.order.data.trans_sub_type
                      )
                    "
                  >
                    <b-button
                      block
                      variant="outline-primary"
                      class="mb-2"
                      @click="goBack"
                    >
                      Back to Customer
                    </b-button>
                  </b-col>
                  <b-col
                    lg="3"
                    class="float-right pr-0"
                    v-if="
                      state.billing.billing.order.data.trans_sub_type == 'sales'
                    "
                  >
                    <b-button
                      block
                      class="w-100"
                      id="remark-btn"
                      v-b-modal.remark
                      variant="primary"
                    >
                      <span v-if="state.billing.billing.remark != ''"
                        >Edit Remark</span
                      >
                      <span v-else>Add Bill Remark</span>
                    </b-button>
                    <b-tooltip
                      target="remark-btn"
                      triggers="hover"
                      placement="bottomleft"
                      :disabled="
                        state.billing.billing.remark == '' ||
                          checkInvoiceSuccess == true
                      "
                    >
                      <span v-text="state.billing.billing.remark" />
                    </b-tooltip>
                    <b-modal
                      hide-footer
                      centered
                      id="remark"
                      title="Add Remark"
                      ref="remark-modal"
                    >
                      <b-form @submit.prevent="saveRemarks">
                        <div class="remark-wrapper">
                          <b-form-textarea
                            placeholder="Add remark... "
                            id="remark-input"
                            aria-describedby="remark-validation"
                            cols="30"
                            rows="3"
                            no-resize
                            v-model="$v.form.remark.$model"
                            autofocus
                          />
                          <!-- <upload-image /> -->
                        </div>
                        <b-form-invalid-feedback id="remark-validation"
                          >Please enter your remark</b-form-invalid-feedback
                        >

                        <div class="d-flex justify-content-end  mt-5">
                          <b-button
                            class="mr-1"
                            type="reset"
                            style="padding:0.5rem 2rem !important"
                            @click="clearRemarks"
                            :disabled="$v.form.$invalid"
                            id="clear-bill-remark"
                          >
                            <span v-if="!$loading">Clear</span>
                          </b-button>
                          <b-button
                            variant="primary"
                            class="ml-1"
                            type="submit"
                            style="padding:0.5rem 2rem !important"
                            :disabled="$v.form.$invalid"
                            id="save-bill-remark"
                          >
                            <span v-if="!$loading">Save</span>
                            <b-spinner small v-if="$loading" />
                          </b-button>
                        </div>
                      </b-form>
                    </b-modal>
                  </b-col>
                </div>
              </b-col>
              <b-col md="8" v-if="checkInvoiceSuccess">
                <div class="align-items-center text-right">
                  <b-col lg="3" class="float-right p-0">
                    <b-button
                      block
                      id="new-bill-btn"
                      @click="newBill"
                      variant="primary"
                    >
                      New Bill
                    </b-button>
                  </b-col>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section class="checkout">
        <b-container fluid>
          <b-row>
            <b-col lg="4" class="fadein">
              <div class="table-dark-bg box-shadow p-3 pb-0">
                <!-- <b-row>
                  <b-col lg="6">
                    <b-form-group id="input-group-1" label="Amount Payable" label-for="amt-pay">
                      <b-form-input
                        id="amt-pay"
                        type="number"
                        v-model="payAmt"
                        required
                        placeholder="₹ 0.00"
                        :disabled="splitPayment == false"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6"></b-col>
                </b-row>-->
                <payment-methods
                  :amount="payAmt"
                  :multiple="splitPayment"
                  v-if="checkInvoiceSuccess == false"
                  @pay-amt="getPayAmt"
                />
                <payment-done v-if="checkInvoiceSuccess == true" />
              </div>
              <customer-info-checkout
                v-if="checkInvoiceSuccess == false"
                :amount="
                  splitPayment
                    ? payAmountInputBox
                    : parseFloat(state.billing.billing.total_payable).toFixed(2)
                "
              />
            </b-col>
            <b-col lg="8" class="fadein pl-0 ">
              <order-summary />
            </b-col>
          </b-row>
        </b-container>
      </section>

      <!-- stop back modal -->
      <!-- <b-modal id="stop_back" size="sm" hide-footer hide-header centered>
        <ul>
          <li>
            <img src="../assets/images/alert.svg" class="text-center" alt />
          </li>
          <li>
            <p class="mb-4">{{ splitMsg }}</p>
          </li>
        </ul>

        <button
          type="button"
          class="btn btn-danger float-right px-4"
          @click="$bvModal.hide('stop_back')"
        >
          <span v-if="$loading == false">Continue</span>
          <b-spinner small v-if="$loading == true"></b-spinner>
        </button>
        <button class="btn grey-outline-btn float-left px-4">Cancel Bill</button>
      </b-modal>-->

      <b-modal
        hide-footer
        title="Remove Voucher"
        ref="remove-voucher"
        id="remove-voucher"
        centered
        size="sm"
      >
        <p>Remove voucher before proceeding!</p>
        <b-row>
          <b-col md="12" class="text-right">
            <b-button
              variant="danger"
              @click="removeAllVoucher"
              id="remove-voucher-dialog-btn"
            >
              <span v-if="$loading == false">Remove Voucher</span>
              <b-spinner small v-if="$loading == true"></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
        centered
        hide-footer
        hide-header
        ref="tag-due-date"
        id="tag-due-date"
        no-close-on-esc
        no-close-on-backdrop
        size="sm"
      >
        <h6 class="mb-4">Fulfilment Options</h6>
            <label for="due-date-picker">Due Date <span class="text-danger">*</span> </label>
            <b-form-group id="order-pos-due-date" class="creditnote-datepicker">
              <b-input-group>
                <template v-slot:append>
                  <b-input-group-text
                    ><font-awesome-icon :icon="['fa', 'calendar-alt']"
                  /></b-input-group-text>
                </template>
                <datepicker
                  id="datepicker"
                  input-class="form-control w-100"
                  placeholder="Select Date"
                  :disabled-dates="disabledDates"
                  v-model="orderPosDueDate"
                ></datepicker>
              </b-input-group>
            </b-form-group>
            <b-form-group>
               <label for="refund-type">Fulfilment Store</label>
              <b-form-input
                id="order-due-date-fulfilment"
                name="Order-ful-store"
                placeholder="Select default store"
                style="cursor: default;"
                readonly
                value="Default Store"
              />
            </b-form-group>
        <b-row class="mt-5">
          <b-col md="6" class="pr-1">
            <b-button
              variant="outline-primary"
              @click="$refs['tag-due-date'].hide()"
              block
              v-show="!checkEmpty(state.billing.orderPos.due_date)"
              >Cancel</b-button
            >
          </b-col>
          <b-col md="6" class="pl-1">
            <b-button
              variant="primary"
              :disabled="$loading || orderPosDueDate == ''"
              block
              @click="saveDate"
              >Continue</b-button
            >
          </b-col>
        </b-row>
      </b-modal>
    </template>
  </dashboard>
</template>

<script>
import Dashboard from "../views/Dashboard";
import ToggleBtn from "../components/ToggleButton";
import PaymentMethods from "../components/PaymentMethods";
import OrderSummary from "../components/OrderSummary";
import PaymentDone from "../components/PaymentDone";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import CustomerInfoCheckout from "../components/CustomerInfoCheckout";
import { BTooltip } from "bootstrap-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { mapState } from "vuex";
import * as msg from "../message";
import db from "../database";
import axios from "axios";
import UploadImage from "../components/UploadImage";
import Datepicker from "vuejs-datepicker";
//import { mapState } from 'vuex'

library.add(faQuestionCircle, faPen);

export default {
  name: "checkout",
  mixins: [validationMixin],
  components: {
    Dashboard,
    ToggleBtn,
    BTooltip,
    PaymentMethods,
    OrderSummary,
    PaymentDone,
    CustomerInfoCheckout,
    UploadImage,
    Datepicker,
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.path == "/billing" &&
      this.state.billing.billing.order.data.transaction_sub_type == "order"
    )
      this.$store.commit("billing/setOrderDueDate", "");

    if (
      this.transTypeDeposit ||
      (to.name == "invoices/order-completed" &&
        this.state.billing.billing.order.data.transaction_sub_type == "order" &&
        this.state.billing.trans_sub_type == "order") ||
      this.state.billing.billing.order.data.trans_sub_type == "Credit-Note" ||
      this.transTypeRefundNote
    ) {
      next();
      return;
    }
    if (this.isGvSale) {
      next();
      return;
    }
    if (this.state.billing.billing.invoice.data == "") {
      if (
        this.state.billing.billing.total_payable !=
          this.state.billing.billing.cart.total &&
        this.state.billing.billing.total_payable > 0
      ) {
        if (this.state.billing.billing.vocher_list.length != 0) {
          console.log("error");
          this.$refs["remove-voucher"].show();
        } else {
          this.$bvModal.show("stop_back");
        }
        next(false);
      } else {
        console.log("back");
        if (this.isOfflineEnabled) {
          let order_state = "";
          if (this.state.billing.billing.order.data != "") {
            db.transaction(
              "rw",
              db.cart,
              db.order,
              db.payment,
              db.invoiceId,
              async () => {
                if (this.state.system.isOffline == true) {
                  order_state = "order_id";
                } else {
                  order_state = "online_order_id";
                }
                await db.order
                  .where(order_state)
                  .equals(
                    this.state.billing.billing.order.data.order_id.toString()
                  )
                  .first()
                  .then((prod) => {
                    let products = JSON.parse(prod.cart_id);
                    products.map((item) => {
                      db.cart.update(item, { status: "process" });
                    });
                    db.order.delete(prod.id);
                  });
                await db.payment
                  .where(order_state)
                  .equals(
                    this.state.billing.billing.order.data.order_id.toString()
                  )
                  .delete();
                await db.invoiceId
                  .where(order_state)
                  .equals(
                    this.state.billing.billing.order.data.order_id.toString()
                  )
                  .delete();
              }
            ).then(() => {
              next();
            });
          }
          next();
        } else {
          next();
        }
      }
    } else {
      next();
    }
  },
  data() {
    return {
      Title: "Lay-by Sale",
      payAmt: 0,
      splitPayment: false,
      splitMsg: "",
      payAmountInputBox: "",
      form: {
        remark: "",
      },
      diff: 0,
      url: "http://localhost:8080/",
      orderPosDueDate: "",
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
    };
  },
  validations: {
    form: {
      remark: {
        required,
        minLength: minLength(3),
      },
    },
  },
  created() {
    this.splitMsg = msg.SPLIT_MESSAGE;
  },
  // watch: {
  //   payAmt() {
  //     if (this.invoice.data == "") {
  //       if (this.payAmt > this.state.billing.order.data.total) {
  //         alert("Enter amount is grater then bill amount");
  //       }
  //     }
  //   }
  // },
  // watch: {
  //   isLayByFlagAPI(val) {
  //     console.log("stats: " + this.isLayByFlagAPI);
  //     if (this.isLayByFlagAPI == true) {
  //       if (this.state.billing.invoice.data != "") {
  //         this.diff =
  //           this.state.billing.layBy_Amt - this.state.billing.total_payable;
  //         if (this.diff > 0) {
  //           if (this.isLayBy == false) {
  //             this.isLayBy = true;
  //           } else {
  //             this.isLayBy = false;
  //           }
  //         }
  //       }
  //     }
  //   }
  // },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    checkSplitPayEnble() {
      let count = 0;
      this.state.system.settings.payment_type.map((item) => {
        if (item.status == 1) {
          count++;
        }
      });
      return count;
    },
    checkInvoiceSuccess() {
      let invoice = this.state.billing.billing.invoice;
      if (invoice.data != "") {
        if (
          this.state.billing.billing.total_payable == 0 ||
          this.state.billing.billing.total_payable == "0.00"
        ) {
          // this.$router.push(
          //   "/order-summary/" +
          //     this.state.billing.billing.order.data.order_id +
          //     "/success"
          // );
          // this.$store.commit("billing/newBilling");
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    isCheckout() {
      return this.$store.getters["billing/isCheckout"];
    },
    isOfflineEnabled() {
      let check = false;
      if (
        this.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        this.state.system.settings.vendor_app_menu.offline.status == 1
      ) {
        check = true;
      }
      return check;
    },
    refundMode() {
      let check = false;
      if (this.state.billing.billing.refund_mode) {
        check = true;
      }
      return check;
    },
    isOrderBtnEnabled() {
      if (
        parseFloat(this.state.billing.billing.order.summary.amount_paid) >=
        this.$store.getters.isOmsMiniAmount.amount
      ) {
        return false;
      } else {
        return true;
      }
    },
    transTypeDeposit() {
      let check = false;
      if (this.state.billing.billing.order.data.trans_sub_type == "Deposit-DN")
        check = true;
      return check;
    },
    transTypeRefundNote() {
      let check = false;
      if (this.state.billing.billing.order.data.trans_sub_type == "Refund-CN")
        check = true;
      return check;
    },
    isGvSale() {
      return this.state.giftVoucher.isGvSale;
    },
  },
  mounted() {
    this.orderDueDate("mounted");
    // if (
    //   this.state.billing.layBy_Amt == 0 &&
    //   this.state.billing.invoice.data == ""
    // ) {
    //   this.isLayBy = false;
    // }
    // if (this.state.billing.order.data == "") {
    //   this.$router.push("billing");
    // }
    // let name = "";
    // if (this.state.billing.invoice.data == "") {
    //   name = "order";
    // } else {
    //   name = "invoice";
    // }
    // this.payAmt = this.state.billing[name].summary.total_payable.toFixed(2);
  },
  methods: {
    removeAllVoucher() {
      this.$loading = true;

      let postData = {
        responseFormat: "ARRAY",
        order_id: this.state.billing.billing.order.data.order_id,
        type: "voucher",
        all: 1,
        total_payable: this.state.billing.billing.total_payable,
        voucher_id: "",
        voucher_code: "",
        url: "remove-voucher",
      };
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(data.url, data)
        .then((res) => {
          if (res.data.status == "fail") {
            this.$loading = false;
          } else {
            this.$store.commit("billing/saveOrderSummay", res.data);
            this.$store.commit("billing/clearVoucherList");
            this.$store.commit(
              "billing/getTotalPayable",
              res.data.order_summary.total_payable
            );
            this.$refs["remove-voucher"].hide();
            this.$loading = false;
          }
        })
        .catch((err) => {
          this.$loading = false;
          console.log(err);
        });
    },
    saveRemarks() {
      this.$loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.$loading = false;
        this.state.billing.billing.remark = this.form.remark;
        this.$store.dispatch("billing/saveRemark", this.form.remark);
        this.$refs["remark-modal"].hide();
        let alertData = {
          message: msg.REMARK_ADDED,
          type: "success",
        };
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", alertData);
      }
    },
    clearRemarks() {
      this.form.remark = "";
      this.state.billing.billing.remark = "";
      // this.$v.$anyError = false;
    },
    splitPaymentToggle(data) {
      this.splitPayment = data;
    },
    getPayAmt(data) {
      this.payAmountInputBox = data;
    },
    orderCreation() {
      if (!this.$store.getters.orderPaymentMode) {
        this.$router.push(
          "/order-summary/" + this.state.billing.billing.order.data.order_id
        );
        return;
      }
      this.$loading = true;
      this.$store
        .dispatch("billing/orderCreation")
        .then(() => (this.$loading = false))
        .catch(() => (this.$loading = false));
      // let postData = {
      //   order_id: this.state.billing.billing.order.data.order_id,
      //   url: "oms/order-creation",
      // };
      // let data = Object.assign(
      //   postData,
      //   this.essentialsData,
      //   this.customerData
      // );
      // axios.post(data.url, data).then((res) => {
      //   this.$loading = false;
      //   this.$store.commit("billing/saveInvoice", res.data);
      //   this.$store.commit("billing/getTotalPayable", 0);
      //   this.$store.commit("billing/setTransactionSubType", "order");
      //   this.$router.push(
      //     "/order-summary/" +
      //       this.state.billing.billing.order.data.order_id +
      //       "/success"
      //   );
      //   this.$store.commit("billing/newBilling");
      //   // window.location.replace("#/order-management");
      // });
    },
    newBill() {
      if (this.isGvSale) {
        this.$store.commit("giftVoucher/cartData", {
          cart_details: [],
          group_cart_details: [],
          subtotal: 0,
          total_amount: 0,
          total_group: 0,
          total_item_in_cart: 0,
          total_tax: 0,
        });
        this.$router.push("/gift-vouchers");
      } else this.$router.push("billing");
      this.$store.dispatch("billing/newBill");
    },
    goBack() {
      window.history.back();
    },
    orderDueDate(src) {
      if (src == "btn") {
        let date = this.state.billing.orderPos.due_date.toString();
        this.orderPosDueDate = new Date(date);
        this.$refs["tag-due-date"].show();
        return;
      }
      if (
        this.$store.getters.isOMSEnabled &&
        this.state.billing.billing.billing_mode == "order" &&
        !["Refund-CN", "Credit-Note", "Deposit-DN"].includes(
          this.state.billing.billing.order.data.trans_sub_type
        ) &&
        this.state.billing.trans_sub_type != "order"
      )
        if (this.checkEmpty(this.state.billing.orderPos.due_date))
          this.$refs["tag-due-date"].show();
    },
    saveDate() {
      this.$refs["tag-due-date"].hide();
      this.$store.commit(
        "billing/setOrderDueDate",
        this.$moment(this.orderPosDueDate).format("YYYY-MM-DD")
      );
    },
  },
  beforeDestroy() {
    if (
      (this.$router.currentRoute.name != "billing" &&
        this.state.billing.billing.order.data.transaction_sub_type ==
          "order") ||
      this.transTypeDeposit ||
      this.state.billing.billing.order.data.trans_sub_type == "Credit-Note" ||
      this.transTypeRefundNote
    ) {
      this.$store.commit("billing/removeCustomer");
      return;
    }

    if (this.state.billing.billing.invoice.data != "") {
      this.$store.commit("billing/newBilling");
    }
  },
};
</script>
<style lang="scss" scoped>
.btn:hover {
  color: #fff;
}
.modal-body .form-control:read-only {
  background-color: transparent !important;
  border: 1px #c0c0c0 solid !important;
  color: #808080;
}
.return-mode {
  padding-top: 3px !important;
}
#order-pos-due-date {
  border: 1px #c0c0c0 solid !important;
  border-radius: 6px;
}
.theme-dark {
  h6 {
    color: #c0c0c0 !important;
  }
}
</style>
